import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceCustomFieldCleanupRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-custom-field-cleanup',
	path: '/jira/settings/system/performance/metrics/customfield/cleanup',
};
